import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { shoppingCart } from '../models/shoppingCart';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-shoppingcart',
  templateUrl: './shoppingcart.component.html',
  styleUrls: ['./shoppingcart.component.css']
})
export class ShoppingcartComponent implements OnInit {
shoppingCartAddObj:shoppingCart
shoppingCartUpdateObj:shoppingCart
  showFilter:boolean=false
  userSessionData;any;
  userDetails:any;
  read:any;
  delete:any;
  write:any;
  export:any
  dataSource: any;
  tableData: [] = [];
  showCustomisedSearch:boolean=false;
  searchValue:any;
  filterValueSelected:any
  show:boolean=false;
  userAccountsList:any;
  currentInventoryList:any;
  myurl:string;
  theDate:any;
  minDate = new Date();

  displayedColumns = [ 'AccountEmailId','_id','ProductId','ProductName','productImage','Description','RequiredQuantity','StockUnit','PlannedPurchaseDate','UploadType','vendor','Price','DateOfCreation','AddedByUserId','productStatus','Actions']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("shoppingCart") form: any;
  @ViewChild("shoppingCartUpdate", {static: true}) formUpdate: any;
  productImageId: any;
  constructor(private cs:CucurachaAdminService,private excelService: ExcelService,private toastr: ToastrManager) {
    this.shoppingCartAddObj=new shoppingCart();

    this.myurl = this.cs.endpoint;
    this.shoppingCartUpdateObj=new shoppingCart();

   }
   viewImages(id:any){
    this.productImageId=id
  }  
  filter() {
    this.getAllShoppingCartManagement()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""



    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""




    }
  }
  saveShoppingCart(){
    this.shoppingCartAddObj.adminId=this.userDetails._id

    this.cs.saveShoppingCart(this.shoppingCartAddObj).subscribe((data) => {
      if(data.result ){
        this.toastr.successToastr(data.message);
        this.form.reset();
        this.getAllShoppingCartManagement();

        
        }
       else if(data.err){
        this.toastr.warningToastr(data.message);
  
       }
        else{
          this.toastr.errorToastr(data.message);
  
        }
    })
  }
  addShoppingCart() {

    if (this.show == false) {
      this.show = true
    }
    else {

      this.show = false
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllShoppingCartManagement();

  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForShoppingCart(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllShoppingCartManagement()
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'ShoppingCartMangement');
    this.cs.exportLogAdd(this.userDetails.emailId, 'ShoppingCartMangement').subscribe((data) => {
    })
  }
  getAllShoppingCartManagement(){
    this.cs.getAllShoppingCartManagement().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  getAllUserAccountsByStatus() {
    this.cs.getAllAccountsByStatus().subscribe((data) => {
      this.userAccountsList = data
    })
  }
  getByCurrentInventoryStatusandEmailID(id:any){
    this.cs.getByCurrentInventoryStatusandEmailID(id).subscribe((data) => {
      this.currentInventoryList=data
    })
  }
  
  getByShoppingCartId(id:any){
    this.cs.getByShoppingCartId(id).subscribe((data) => {
      console.log(data[0])
      this.shoppingCartUpdateObj._id = data[0]._id;
      this.shoppingCartUpdateObj.accountId = data[0].accountId;
      this.shoppingCartUpdateObj.productId = data[0].productId;
      this.shoppingCartUpdateObj.requiredQuantity = data[0].requiredQuantity;
      this.theDate = data[0].plannedPurchasedate;
    })
  }
  deleteShoppingCart(id:any){
    this.cs.deleteShoppingCart(id).subscribe((data) => {
      this.getAllShoppingCartManagement()
      this.toastr.warningToastr("Data  Deleted");


    })
  }
  updateShoppingCart(){
  this.shoppingCartUpdateObj.plannedPurchasedate=this.theDate
    this.cs.updateShoppingCart(this.shoppingCartUpdateObj).subscribe((data) => {
      if (data.result) {
        this.getAllShoppingCartManagement();
        this.toastr.infoToastr(data.message);
        this.formUpdate.reset();

      }
      else if (data.err) {
        this.toastr.warningToastr(data.message);

      }
      else {
        this.toastr.errorToastr(data.message);

      }
    })
  }
 
 
  saveOpenOrders(sid:any){
    this.cs.saveOpenOrders(sid).subscribe((data) => {
      console.log(data)
      if(data.result){
        this.getAllShoppingCartManagement()

        this.toastr.infoToastr(data.message);

      }
      else{
      this.toastr.errorToastr(data.message);
      }


    })

  }
  ngOnInit(): void {
    this.getAllShoppingCartManagement()
    this.getAllUserAccountsByStatus();
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails = data[0]
      this.read = (this.userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].read);
      this.write = (this.userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].write)
      this.delete = (this.userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].delete)
      this.export = (this.userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].export)

    })
  }


}
